import { useGetTransactions } from '@/apis/transactions/hooks/useGetTransactions'
import PageLoader from '@/app/common/components/PageLoader/PageLoader'
import { usePagination } from '@/app/common/hooks/usePagination'
import { selectFamilyApplication, selectSelectedStudent } from '@/storage/applications/familyApplicationSlice'
import { selectProgramID } from '@/storage/program_settings/programSettingsSlice'
import { useSelector } from 'react-redux'
import TransactionsTable from './components/transactions_table'
import { useSearchParams } from 'react-router-dom'

function Page() {
  const [searchParams] = useSearchParams()
  const program_id = useSelector(selectProgramID)
  const application = useSelector(selectFamilyApplication)
  const student = useSelector(selectSelectedStudent)
  console.log(student)
  const {
    currentPage,
    perPage,
    search,
    onSearchChange,
    setCurrentPage,
    setPerPage,
    sortBy,
    sortOrder,
    onSortChange,
    debouncedValue,
    setSortBy,
  } = usePagination()
  const query = useGetTransactions({
    program_id,
    applicant_id: application.applicant_id,
    student_id: searchParams.get('filter') === 'byStudent' ? student?.id : undefined,
    search: debouncedValue,
    paginate: 1,
    per_page: perPage,
    page: currentPage,
    sort_by: sortBy,
    sort_order: sortOrder,
  })

  return (
    <PageLoader query={query}>
      {(data) => {
        return (
          <TransactionsTable
            search={search}
            onSearchChange={onSearchChange}
            onPageChange={setCurrentPage}
            onPerPageChange={setPerPage}
            recordsPerPage={perPage}
            currentPage={currentPage}
            transactions={data.data}
            total_rows={data.total}
            onSortByChange={setSortBy}
            onSortChange={onSortChange}
            sortBy={sortBy}
            sortOrder={sortOrder}
          />
        )
      }}
    </PageLoader>
  )
}

export default Page
